import { safeParseDate, toDateParam } from './dateUtils.js';
import { issueHref } from './url.js';

// The only status meaning "a technician is booked for that date". A paused (STANDBY) or
// cancelled ticket keeps its duedate, so the date alone never says the visit will happen.
export const SCHEDULED_STATUS = 'Intervention Programmée';

// One wording for a missing request_type; matches GPSRequestTypeChart's literal.
export const UNKNOWN_ACTION = 'Non spécifié';

// The DWH stores a Paris midnight as 22:00/23:00 UTC the day before, so a duedate's
// calendar day is its Europe/Paris day, never its UTC one (CU-1242djkgr9v).
const PARIS_DAY = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
});
const parisDay = (value) => {
  const d = safeParseDate(value);
  return d ? PARIS_DAY.format(d) : null;
};

// The single definition of "a time is present": INTERVENTION_TIME is a free-text
// appointment note ("5h", "06:00", "Avant ouverture"), rendered as-is, never parsed.
export const interventionTime = (issue) =>
  typeof issue?.intervention_time === 'string' ? issue.intervention_time.trim() : '';

/**
 * GPS issues -> FullCalendar events: scheduled interventions dated `today` or later, `today`
 * being the viewer's own calendar day. The caller passes it so one clock drives the whole tab.
 */
export const gpsCalendarEvents = (issues, today = toDateParam(new Date())) =>
  (issues || []).reduce((events, issue) => {
    if (issue?.status?.trim() !== SCHEDULED_STATUS) return events;

    const day = parisDay(issue.duedate);
    if (!day || day < today) return events;

    const store = issue.intervention_point || 'Point de vente inconnu';
    // Only a compact time ("5h", "20h30", "9h/10h") prefixes the chip — prose would
    // bury the store name; the modal always shows the full value.
    const time = interventionTime(issue);
    const timePrefix = /^\S{1,7}$/.test(time) ? `${time} · ` : '';
    events.push({
      title: `${timePrefix}${store} · ${issue.request_type || UNKNOWN_ACTION}`,
      start: day,
      allDay: true,
      url: issueHref(issue),
      extendedProps: { issue },
    });
    return events;
  }, []);
